import EmailSignup from '@components/email-signup/EmailSignup';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import useBreakpoints from '@ui/hooks/useBreakpoints';
import { useStyles } from '@ui/utils/makeStyles';
import React from 'react';

type ShoppingMailingListProps = {
  className?: string;
  style?: React.CSSProperties;
}

const ShopperMailingList: React.FC<ShoppingMailingListProps> = (props) => {
  const { className, style } = props;
  const { md } = useBreakpoints();
  const { theme } = useStyles();

  return (
    <Grid
      container
      className={className}
      style={style}
    >
      <Grid
        item
        xs={12}
        md={7}
      >
        <Typography
          component="h2"
          variant="display4Alt"
        >
          Join our Mailing List
        </Typography>
      </Grid>

      <Grid
        item
        xs={12}
        md={5}
      >
        <Typography
          gutterBottom
          style={{
            fontSize: md ? 20 : 14,
            lineHeight: 1.5,
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(4)
          }}
        >
          Sign up for new arrivals, sales, exclusive offers and special events. Unsubscribe anytime.
        </Typography>

        <EmailSignup
          campaignList="shoppers"
        />
      </Grid>
    </Grid>
  );
};

export default ShopperMailingList;
